import { ActionType } from 'typesafe-actions';

import Homepage from '@interfaces/homepage';

import * as types from './types';
import * as actions from './actions';

export type HomepageAction = ActionType<typeof actions>;

export interface HomepageState {
    readonly data: Homepage;
    readonly isLoading: boolean;
    readonly error?: boolean;
}

const initialState: HomepageState = {
    data: {
        researchers: [],
        publications: [],
        themes: [],
        news: []
    },
    isLoading: false,
    error: undefined
};

function reducer(state: HomepageState = initialState, action: HomepageAction): HomepageState {
    switch (action.type) {
        case types.FETCH_HOMEPAGE:
            return fetchHomepage(state);

        case types.FETCH_HOMEPAGE_SUCCESS:
            return fetchHomepageSuccess(state, action);

        case types.FETCH_HOMEPAGE_ERROR:
            return fetchHomepageError(state, action);

        default:
            return state;
    }
}

function fetchHomepage(state: HomepageState) {
    return {
        ...state,
        isLoading: true,
        error: undefined
    };
}

function fetchHomepageSuccess(state: HomepageState, action: any) {
    return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: undefined
    };
}

function fetchHomepageError(state: HomepageState, action: any) {
    return {
        ...state,
        data: initialState.data,
        isLoading: false,
        error: action.payload
    };
}

export default reducer;
